import React from 'react';

// eslint-disable-next-line react/prop-types
const FlagshipRescheduleOrCancel = ({ appLink, androidLink, iosLink }) => (
  <div>
    <div>
      <div className="u-mt-8 u-mb-6">
        <a
          className="u-text-large u-td-none u-dotted-border u-dotted-border--flagship u-co-black u-fw-bold"
          href={appLink}
          target="_blank"
        >
          Reschedule
        </a>
        <span className="u-text-large u-fw-bold"> or </span>
        <a
          className="u-text-large u-td-none u-dotted-border u-dotted-border--flagship u-co-black u-fw-bold"
          href={appLink}
          target="_blank"
        >
          Cancel
        </a>
        <span className="u-text-large u-fw-bold">
          &nbsp;your
          <br />
          appointment using our
          <br />
          free app.
        </span>
      </div>
      <div className="u-flex">
        <a className="c-store-button u-mr-4" href={androidLink || appLink} target="_blank">
          <img src="https://assets.getsquire.com/images/google-play.png" alt="" />
        </a>
        <a className="c-store-button" href={iosLink || appLink} target="_blank">
          <img src="https://assets.getsquire.com/images/app-store.png" alt="" />
        </a>
      </div>
    </div>

    <img
      src="https://assets.getsquire.com/images/flagship-app-mockup.png"
      className="c-flagship-mockup dark-invert"
      alt="Squire App"
    />
    <img
      src="https://assets.getsquire.com/images/flagship-powered-by-squire.png"
      className="c-flagship-powered dark-invert"
      alt="Powered by Squire"
    />
  </div>
);

export default FlagshipRescheduleOrCancel;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/FlagshipRescheduleOrCancel.jsx